import homeData from "../../data/homedata.json";
import Director from "./Director";
import FeaturedProjects from "./FeaturedProjects";
import Hero from "./Hero";
import MovingStats from "./MovingStats";
import Philosophy from "./Philosophy";
import Process from "./Process";
import Services from "./Services";
import Testimonials from "./Testimonials";
import VideoShowcase from "./VideoShowcase";
import WorkWithUs from "./WorkWithUs";

function Home() {
  return (
    <main>
      <Hero content={homeData.hero} />
      <Philosophy content={homeData.philosophy} />
      <FeaturedProjects content={homeData.featuredProjects} />
      <Services content={homeData.services} />
      <MovingStats items={homeData.movingStats} />
      <Director content={homeData.director} />
      <VideoShowcase content={homeData.videoSection} />
      <Process content={homeData.process} />
      <Testimonials content={homeData.testimonials} />
      <WorkWithUs content={homeData.workWithUs} />
    </main>
  );
}

export default Home;
